import { Content } from 'src/contexts/ContentContext';
import { Stack, Switch } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './InventorySortingItem.css';

export const InventoryConfigItem = ({
  contentId,
  disabled,
  isChecked,
  onUpdateConfig,
}: {
  contentId: ContentId;
  disabled?: boolean;
  isChecked: boolean;
  onUpdateConfig: (checked: boolean) => void;
}) => {
  return (
    <Stack
      width="full"
      alignItems="center"
      justifyContent="spaceBetween"
      className={styles.sortingCriteriaContainer}
    >
      <span className={styles.itemContent}>
        <Content id={contentId} />
      </span>
      <Switch
        checked={isChecked}
        onCheckedChange={onUpdateConfig}
        disabled={disabled}
      />
    </Stack>
  );
};
